import { BestPricesBagItem } from '@/modules/mixing/ts/buyers-prices.types';
import { Tooltip } from 'antd';
import classNames from 'classnames';
import { DetalisationTooltip } from '@@/common/components/detalisation-tooltip';
import styles from './index.module.sass';
import infoIcon from '@@/mixing/images/info-icon.svg';
import { useNavigate } from 'react-router-dom';
import {
  IBestPriceBagItem,
  setActivesModalOpen,
} from '@/modules/mixing/store/analytical-mixing.store';
import {
  setSelectedRecipeStore,
  setSleeveToView,
} from '@/modules/mixing/store/recipes.store';
import { $warehousesForMixingData } from '@/widgets/recipe/model';
import { useStore } from 'effector-react';

export const SleeveData = ({
  data,
  odd,
  status,
  warehouse_id,
}: {
  data: IBestPriceBagItem;
  tooltipData: any;
  setTooltipData: (args: any) => void;
  odd: boolean;
  status: string;
  warehouse_id: number;
}) => {
  const warehousesList = useStore($warehousesForMixingData);
  const navigate = useNavigate();
  const getBestOffer = () =>
    data?.buyers?.length > 0
      ? data?.buyers?.reduce(function (prev, current) {
          return prev.price_per_ton > current.price_per_ton ? prev : current;
        })
      : null;
  const buyerPrice =
    data.buyers?.length > 0
      ? data?.buyers
          ?.reduce(function (prev, current) {
            return prev.price_per_ton > current.price_per_ton ? prev : current;
          })
          .price_per_ton?.toLocaleString('ru-RU')
      : null;

  const buyer =
    data.buyers?.length > 0
      ? data?.buyers?.reduce(function (prev, current) {
          return prev.price_per_ton > current.price_per_ton ? prev : current;
        })
      : null;

  return (
    <>
      <div
        className={classNames(styles.sleeveData)}
        style={{
          backgroundColor: odd
            ? 'rgba(255, 255, 255, 0.45)'
            : 'rgba(220, 220, 220, 0.45)',
        }}
      >
        <div className={classNames(styles.sleeve__col, styles.id)}>
          <span className={styles.bold}>{data?.id}</span>
        </div>
        <div className={classNames(styles.sleeve__col, styles.wheatType)}>
          <span className={styles.val}>
            <span className={styles.label}>{getBestOffer()?.class}</span>
            {getBestOffer()?.type}
          </span>
          <span className={styles.val}>{data?.class}</span>
        </div>
        <div className={classNames(styles.sleeve__col, styles.weight)}>
          {/* <span className={styles.label}>вес:</span> */}
          <span className={styles.val}>{data.weight} т</span>
        </div>
        <div className={classNames(styles.sleeve__col, styles.price)}>
          {/* <span className={styles.label}>стоимость:</span> */}
          <span className={styles.val}>
            {getBestOffer()?.price_all?.toLocaleString('ru-RU')}
            {' ₽'}
          </span>
        </div>
        <div className={classNames(styles.sleeve__col, styles.perTon)}>
          {/* <span className={styles.label}>цена покупателя:</span> */}
          <span className={styles.val}>
            {buyerPrice ? (
              <>
                {buyerPrice} ₽/т{' '}
                {status === 'UndefinedCase' || status === 'MoistureAboveTarget' ? (
                  <DetalisationTooltip
                    className={styles.detalisationTooltip}
                    red={true}
                    rangeKm={buyer?.distance}
                    status={
                      status === 'UndefinedCase' && data.offer_humidity > 14
                        ? 'UndefinedCaseWithComment'
                        : status
                    }
                    navigate={navigate}
                  />
                ) : status !== 'UndefinedCase' &&
                  status !== 'MoistureAboveTarget' &&
                  Number(data.offer_humidity) !== Number(data.values.humidity) ? (
                  <DetalisationTooltip
                    className={styles.detalisationTooltip}
                    status="Modify"
                    infoIcon={true}
                    onClick={() => {
                      setSelectedRecipeStore(
                        warehousesList?.find((item: any) => item.id === warehouse_id),
                      );
                      setSleeveToView(data?.id);
                      setActivesModalOpen({ payload: false });
                      navigate('/mixing/recipes-new?active_tab=0');
                    }}
                  />
                ) : (
                  ''
                )}
              </>
            ) : (
              ''
            )}
          </span>
          {/* <span className={styles.val}>{data?.class}</span> */}
          {/* {(status === 'UndefinedCase' || status === 'MoistureAboveTarget') && (
            <DetalisationTooltip
              red={true}
              rangeKm={buyer?.distance}
              status={status as any}
              navigate={navigate}
            />
          )} */}
        </div>

        <div className={classNames(styles.sleeve__col, styles.buyer)}>
          {/* <span className={styles.label}>покупатель:</span> */}
          <span className={styles.val}>
            {status !== 'UndefinedCase' &&
            status !== 'MoistureAboveTarget' &&
            buyer?.buyer ? (
              <Tooltip title={buyer.buyer}>{buyer.buyer}</Tooltip>
            ) : (
              ''
            )}
          </span>
        </div>

        <div className={classNames(styles.sleeve__col, styles.range)}>
          <span className={styles.val}>
            {status !== 'UndefinedCase' &&
            status !== 'MoistureAboveTarget' &&
            buyer?.distance ? (
              `${(+buyer.distance).toLocaleString('ru', { maximumFractionDigits: 0 })} км`
            ) : status === 'BuyerPickupEnforced' ? (
              <>
                самовывоз <DetalisationTooltip status={status} />
              </>
            ) : (
              ''
            )}
          </span>
        </div>

        <div className={classNames(styles.sleeve__col, styles.netPrice)}>
          <span className={styles.val}>
            {status !== 'UndefinedCase' &&
            status !== 'MoistureAboveTarget' &&
            status !== 'NoValidDestinations' &&
            status !== 'NoMatchingDistanceCost' &&
            buyer?.netto
              ? `${buyer.netto.toLocaleString('ru')} ₽`
              : ''}
          </span>
          {status !== 'UndefinedCase' && status !== 'MoistureAboveTarget' && (
            <div className={styles.interactive}>
              {status === 'NoValidDestinations' ||
              status === 'NoMatchingDistanceCost' ? (
                <DetalisationTooltip
                  status={status as any}
                  rangeKm={buyer?.distance}
                  navigate={navigate}
                />
              ) : (
                <Tooltip
                  arrow={false}
                  placement="left"
                  color={'#fff'}
                  title={
                    <>
                      <div
                        className={styles.priceDetalisation}
                        style={{ color: '#7E89A5' }}
                      >
                        <span className={styles.row} style={{ display: 'block' }}>
                          <span className={styles.label} style={{ display: 'block' }}>
                            Стоимость пшеницы
                          </span>
                          <span className={styles.val} style={{ display: 'block' }}>
                            {getBestOffer()?.price_all?.toLocaleString('ru-RU')}
                            {' ₽'}
                          </span>
                        </span>
                        <span className={styles.row} style={{ display: 'block' }}>
                          <span className={styles.label} style={{ display: 'block' }}>
                            Стоимость доставки
                          </span>
                          <span
                            className={styles.val}
                            style={{ color: 'rgba(64, 155, 255, 1)', display: 'block' }}
                          >
                            {getBestOffer()?.freight_price?.toLocaleString('ru-RU')}
                            {' ₽'}
                          </span>
                        </span>
                        <span className={styles.row} style={{ display: 'block' }}>
                          <span className={styles.label} style={{ display: 'block' }}>
                            НЕТТО (логистика)
                          </span>
                          <span
                            className={styles.val}
                            style={{ color: 'rgba(0, 126, 60, 1)', display: 'block' }}
                          >
                            {getBestOffer()?.netto?.toLocaleString('ru-RU')}
                            {' ₽'}
                          </span>
                        </span>
                      </div>
                    </>
                  }
                >
                  <img className={styles.infoIcon} src={infoIcon} alt="more info" />
                </Tooltip>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
};
